import { CircularProgress as MuiCircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import type { IconKey } from 'assets/Icon.js';
import { Icon as IconElement } from 'assets/Icon.js';
import type {
  FC,
  ReactElement,
} from 'react';

import { WarningIcon } from '../../icons/WarningIcon/index.js';
import type { ModalProps } from '../Modal/index.js';
import {
  CloseIconButton,
  CloseIconWrapper,
  ConfirmModalDescription,
  ConfirmModalItalicDescription,
  ConfirmModalTitle,
  StyledModal,
} from './ConfirmModal.styles.js';

export interface ConfirmModalProps extends ModalProps {
  title?: string;
  text?: string;
  Icon?: ReactElement | FC | IconKey | null;
  note?: string;
}

export const CircularProgress = () => {
  return <MuiCircularProgress size={55} />;
};

const isElement = (Icon: ReactElement | FC): Icon is ReactElement =>
  (Icon as any).type;

const renderElementIcon = (Icon: ReactElement | FC): ReactElement =>
  (isElement(Icon) ? Icon : <Icon />);

export const ConfirmModal: FC<ConfirmModalProps> = ({
  children,
  title,
  text,
  Icon = WarningIcon,
  note,
  ...props
}) => {
  return (
    <StyledModal {...props}>
      {props.fullScreen && (
        <CloseIconWrapper>
          <CloseIconButton
            onClick={event => props.onClose?.(event, 'backdropClick')}
          />
        </CloseIconWrapper>
      )}
      {Icon === null
        ? null
        : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={2}
              width={67}
              height={68}
            >
              {typeof Icon === 'string'
                ? (
                    <IconElement icon={Icon} />
                  )
                : (
                    renderElementIcon(Icon)
                  )}
            </Box>
          )}
      {children}
      {title && <ConfirmModalTitle data-sentry-unmask>{title}</ConfirmModalTitle>}
      {text && <ConfirmModalDescription>{text}</ConfirmModalDescription>}
      {note && <ConfirmModalItalicDescription>{note}</ConfirmModalItalicDescription>}
    </StyledModal>
  );
};
